import { NgModule, APP_INITIALIZER, ErrorHandler, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';
import { of } from 'rxjs';
import { LocationListReuseStrategy } from './core/location-list-reuse-strategy';

// Core module
import { CoreModule } from './core/core.module';

// Routing
import { AppRoutingModule } from './app-routing-module';

// Root component
import { App } from './app';

// Shared module (will be created)
import { SharedModule } from './shared/shared.module';

import { AuthService } from './core/services/auth.service';
import { GlobalErrorHandler } from './core/error-handler/global-error-handler';

function initAuth(authService: AuthService, platformId: Object) {
  return () => {
    // No localStorage on the server — SSR always boots anonymous; the
    // browser bootstrap after hydration re-runs this same check client-side.
    if (!isPlatformBrowser(platformId)) return of(null);
    const token = localStorage.getItem('jwt');
    return (token && authService.isRealUserJwt(token)) ? authService.loadCurrentUser() : of(null);
  };
}

@NgModule({
  declarations: [
    App
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    SharedModule,
    AppRoutingModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthService, PLATFORM_ID],
      multi: true
    },
    { provide: RouteReuseStrategy, useClass: LocationListReuseStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  bootstrap: [App]
})
export class AppModule { }
